import { createFileRoute } from "@tanstack/react-router";
import ProductHubList from "@/pages/ProductHubList";

export const Route = createFileRoute("/chainsaws/buying-guides")({
  component: () => <ProductHubList hubSlug="chainsaws" variant="buying-guides" />,
});
